import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-job-adv',
  templateUrl: './job-adv.component.html',
  styleUrls: ['./job-adv.component.css']
})
export class JobAdvComponent implements OnInit {

  @Input("job_adv")
  private job: job_adv;

  private isCollapsed:boolean = true;

  constructor() { }

  ngOnInit() {
  }

  changeCollapse():void {
    this.isCollapsed = !this.isCollapsed;
  }

}



// WEBPACK FOOTER //
// ./src/app/careers/job-adv/job-adv.component.ts